import {createApi} from "@reduxjs/toolkit/dist/query/react"
import {apiQuery} from "../../utils/api-config";
import {Response} from "../../types/response/Response";
import {ExtendedPrintDTO} from "../../types/configuration/ExtendedPrintDTO";

export const configurationApi = createApi({
    reducerPath: "configuration",
    baseQuery: apiQuery,
    tagTypes: ["extended-print"],
    endpoints: builder => ({
        getExtendedPrint: builder.query<Response<ExtendedPrintDTO>, void>({
            query: () => '/configurations/extended-print',
            providesTags: ['extended-print']
        })
    })
})

export const {useGetExtendedPrintQuery} = configurationApi
